import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'types/state';

export const selectIsMemberCodeLoading = createSelector(
  (state: GlobalState) => state.memberCodeStatus,
  (status) => status.isLoading,
);

export const selectIsGenerateCodeLoading = createSelector(
  (state: GlobalState) => state.memberCodeStatus,
  (status) => status.isGenerateCodeLoading,
);

export const selectFetchMemberCodeError = createSelector(
  (state: GlobalState) => state.memberCodeStatus,
  (status) => status.fetchCodeError,
);

export const selectGenerateCodeError = createSelector(
  (state: GlobalState) => state.memberCodeStatus,
  (status) => status.generateCodeError,
);

export const selectDistributionRequest = createSelector(
  (state: GlobalState) => state.memberCodeStatus,
  (status) => status.distributionRequest,
);
